module.exports = __webpack_public_path__ + "media/produktion-pos-1.5cd51ef4.mp4";